import { Files, FilesKind, FilesMainKind } from '@flatsy/types/Files'

export const getFilesByMainKind = (files: Files[], kind?: FilesMainKind): Files[] => {
  const filesByKind = files.filter((file) => file.main_kind === kind)

  return filesByKind
}

export const getFilesByKind = (files: Files[], kind?: FilesKind): Files[] => {
  const filesByKind = files.filter((file) => file.kind === kind)

  return filesByKind
}
